import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
        <p className="text-gray-600 mt-2">How we protect your data</p>
      </div>
      
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-700">
          This is the Privacy Policy page. Content will be implemented here.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPage;
